import React, { useState, useEffect,useContext } from 'react'
import '../../styles/create_template.css';

import { Link,useParams } from 'react-router-dom'
import BackLoader from '../../components/backloader';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import { useNavigate } from 'react-router-dom'
import DynamicIcon from '../../components/dynamicicon'
import JisButton from '../../components/controls/jisButton';


function PreviewTemplate() {
const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const {id} = useParams();
  //  const linkurl=id==null?'/templates/create':
    const tempUrl= `${Constants.apiUrl}/filing/loadTemplateDoc/${id}`;
    const [template, setTemplate]=useState({});
    const [upline, setUpline] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [html, setHtml] =useState('');

    useEffect(() => {
        
        LoadTemplate();
    
  }, [id])

  const LoadTemplate=()=>{
    setIsLoading(true);
    fetch(tempUrl, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);
            if(data.code==0){
             //   setTemplate(data.template);
              setHtml(atob(data.upline.templateHtml))  ;
              setUpline(data.upline);
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}

  return (
    <div className='view-temp'>
     
        <div className="body">
        

            <div className="doc">
                <h3>{upline.documentTitle}</h3>
                <div className="paper-doc"> <div  className='htmlwrap' dangerouslySetInnerHTML={{__html: html}}></div></div>
              <div  className='no-print'><JisButton onClick={()=>window.print()} icon="print">Print</JisButton></div>  
            </div>
        </div>
    </div>
  )
}

export default PreviewTemplate